import axios from 'axios';
import { normalizeEnumOption } from './enumOption';

// 获取 发车时间 限制
export const getVehicleFeeOrderDay = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/vehicleFeePaymentParBO.ajax?cmd=getVehicleFeeOrderDay',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 保存车辆费用申请
export const doSaveVehicleFee = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/vehicleFeePaymentParBO.ajax?cmd=doSaveVehicleFee',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 费用明细查询
export const doQueryVehicleFeeDetailList = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/vehicleFeePaymentParBO.ajax?cmd=doQueryVehicleFeeDetailList',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 查询车辆费用的费用类型
export const queryVehicleExpenseTypes = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/vehicleFeePaymentParBO.ajax?cmd=queryVehicleExpenseTypes',
    method: 'post',
    data,
  }).then(async (res) => {
    let result = [];
    if (res.items && res.items.length) {
      result = res.items.map(normalizeEnumOption);
    }
    resolve(result);
  }).catch((err) => {
    reject(err);
  });
});

// 车辆费用申请报销列表查询
export const queryVehicleFeeBeanOutPage = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/vehicleFeePaymentParBO.ajax?cmd=queryVehicleFeeBeanOutPage',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 新增修改借支申请
export const saveOrUpdateOaLoan = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/oaLoan.ajax?cmd=saveOrUpdateOaLoan',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 查询借支管理列表
export const queryOaLoanPageList = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/oaLoan.ajax?cmd=queryOaLoanPageList',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 根据车牌号码查询绑定油卡卡号
export const queryOilCardNumListByPlateNumber = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/reportFeeBO.ajax?cmd=queryOilCardNumListByPlateNumber',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 根据车牌号码查询绑定ETC卡号
export const queryEtcCardNumListByPlateNumber = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/reportFeeBO.ajax?cmd=queryEtcCardNumListByPlateNumber',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 管理费用申请 - 费用类型
export const queryManagerTypes = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/payManagerBO.ajax?cmd=queryManagerTypes',
    method: 'post',
    data,
  }).then(async (res) => {
    let result = [];
    if (res.items && res.items.length) {
      result = res.items.map((item) => ({
        label: item.costName,
        value: item.costID,
      }));
    }
    resolve(result);
  }).catch((err) => {
    reject(err);
  });
});

// 维保列表
export const maintenanceList = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/repairPreApplyBO.ajax?cmd=doQueryPreList',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});
// 维保选择列表
export const maintenanceChooseList = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/repairPreApplyBO.ajax?cmd=doQueryServiceRepairOrderSave',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});
// 维保查询配件信息
export const maintenancePairInfoList = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/repairPreApplyBO.ajax?cmd=getRepairOrderParts',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 维保申请取消
export const maintenanceCancel = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/repairPreApplyBO.ajax?cmd=doCancelPre',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});
// 维保申请详情
export const maintenanceDetail = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/repairPreApplyBO.ajax?cmd=getRepairPreApply',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});
// 维保申请修改
export const maintenanceEdit = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/repairPreApplyBO.ajax?cmd=doSaveOrUpdatePre',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});
// 维保费用申请修改
export const maintenanceCostEdit = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/repairPreApplyBO.ajax?cmd=doSaveOrUpdate',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});
// 事故列表
export const accidentList = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/vehicleServiceBO.ajax?cmd=doQueryAccidentList',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});
// GPS列表
export const gpsList = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/vehicleServiceBO.ajax?cmd=doQueryVehicleStandingBookInfoOut',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});
// 违章费用列表
export const violationList = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/violationBO.ajax?cmd=doQueryNew',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});
// 年审费用列表
export const annualCostList = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/vehicleFeePaymentBO.ajax?cmd=getCostDetailListByType',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});
// 车辆费用列表
export const carCostList = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/vehicleFeePaymentParBO.ajax?cmd=doQuery',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});
// 车辆费用申请取消
export const carCostCancelApply = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/vehicleFeePaymentParBO.ajax?cmd=updateVehicleFeePaymentState',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 车辆费用申请审核
export const carCostApprove = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/vehicleFeePaymentParBO.ajax?cmd=checkDeductAmount',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 车辆费用详情
export const carCostDetail = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/vehicleFeePaymentParBO.ajax?cmd=getVehicleFeePayment',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 车辆费用修改
export const carCostEdit = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/vehicleFeePaymentParBO.ajax?cmd=doSaveVehicleFeePaymentPar',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});
// 选择抵扣列表
export const deductList = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/ac/payManagerBO.ajax?cmd=getOaLoanTable',
    method: 'post',
    data,
  }).then(async (res) => {
    res.items.forEach((item) => {
      item.amount = item.amount / 100;
      item.payedAmount = item.payedAmount / 100;
      item.canDeductedAmount = item.canDeductedAmount / 100;
      item.deductedAmount = item.deductedAmount / 100;
      item.currentRecordDeductedAmount = item.currentRecordDeductedAmount / 100;
    });
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});
// 费用明细 - 费用类型
export const costDetailCostType = async () => new Promise((resolve, reject) => {
  axios({
    url: '/manualPaymentBO.ajax?cmd=getChildCostTypeList',
    method: 'post',
    data: {
      busiId: '22000070',
      parentIds: '2000,3000,2011',
    },
  }).then(async (res) => {
    const result = [];
    if (res.items && res.items.length !== 0) {
      res.items.forEach((item) => {
        let children = null;
        if (item.children && item.children.length !== 0) {
          children = item.children.map((child) => ({
            label: child.name,
            value: child.value,
          }));
        }
        result.push({
          label: item.name,
          value: item.value,
          children,
        });
      });
    }
    resolve(result);
  }).catch((err) => {
    reject(err);
  });
});
// 费用明细列表
export const costDetailList = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/vehicleFeePaymentParBO.ajax?cmd=doQueryDetailList',
    method: 'post',
    data,
  }).then(async (res) => {
    axios({
      url: '/vehicleFeePaymentParBO.ajax?cmd=doQueryDetailTotalAmt',
      method: 'post',
      data,
    }).then(async (total) => {
      resolve({
        total,
        ...res,
      });
    }).catch((err) => {
      reject(err);
    });
  }).catch((err) => {
    reject(err);
  });
});
// 管理列表
export const manageList = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/payManagerBO.ajax?cmd=doQueryAllPayManager',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 查询充值收款账户
export const manageRechargeReceiptAccount = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/oilRechargeAccountBO.ajax?cmd=getRechargeInfo',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 管理费用 - 费用类型
export const manageCostType = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/payManagerBO.ajax?cmd=getManagerTypes',
    method: 'post',
    data,
  }).then(async (res) => {
    const result = [];
    if (res.items && res.items.length !== 0) {
      res.items.forEach((item) => {
        let children = null;
        if (item.children && item.children.length !== 0) {
          children = item.children.map((child) => ({
            label: child.name,
            value: child.value,
          }));
        }
        result.push({
          label: item.name,
          value: item.value,
          children,
        });
      });
    }
    resolve(result);
  }).catch((err) => {
    reject(err);
  });
});

// 管理列表 - 获取该费用类型下可报销金额
export const manageGetBudgetBalance = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/payManagerBO.ajax?cmd=getFinancebudgetBalance',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 抵扣明细
export const manageDeductDetail = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/oaLoan.ajax?cmd=getOaLoanDeductDetails',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});
// 取消申请
export const manageCancel = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/payManagerBO.ajax?cmd=updatePayManagerState',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 申请详情
export const manageDetail = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/payManagerBO.ajax?cmd=getPayManager',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 添加申请
export const manageEdit = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/payManagerBO.ajax?cmd=doSavePayManager',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 借支列表
export const borrowList = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/oaLoan.ajax?cmd=queryOaLoan',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});
// 借支修改
export const borrowEdit = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/oaLoan.ajax?cmd=saveOrUpdateOaLoanCar',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 借支详情
export const borrowDetail = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/oaLoan.ajax?cmd=queryOaLoanById',
    method: 'post',
    data,
  }).then(async (res) => {
    if (data.isEdit === 2) { // 审核
      const approveRes = await axios({
        url: '/oaLoan.ajax?cmd=queryOaLoanById',
        method: 'post',
        data,
      });
      if (!approveRes.failed) {
        resolve({
          obj: res,
          ver: approveRes,
        });
      }
    } else { // 详情
      resolve(res);
    }
  }).catch((err) => {
    reject(err);
  });
});

// 借支附件上传
export const borrowFileUpload = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/ac/finance/oaLoan.ajax?cmd=saveOaLoanPic',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 借支核销列表
export const borrowWriteOffList = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/oaLoan.ajax?cmd=queryOaLoanTable',
    method: 'post',
    data,
  }).then(async (res) => {
    if (data.page === 1) {
      borrowWriteOffList.totalRes = await borrowWriteOffTotal(data);
    }
    res.items = [
      {
        lastVerifAmountStr: borrowWriteOffList.totalRes.sumLastVerifAmountDouble,
        payedAmountStr: borrowWriteOffList.totalRes.sumPayedAmountDouble,
        salaryDeductionStr: borrowWriteOffList.totalRes.sumSalaryDeductionDouble,
        noPayedAmountStr: borrowWriteOffList.totalRes.sumNoPayedAmountDouble,
      },
      ...res.items,
    ];
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});
// 借支核销总览
export const borrowWriteOffTotal = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/ac/reports/oaLoan.ajax?cmd=queryOaLoanTableSum',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 上报费用审核列表
export const repostCostApproveList = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/report/reportFeeBO.ajax?cmd=doQuery',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 上报费用审核 - 详情
export const repostCostApproveDetail = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/reportFeeBO.ajax?cmd=getOrderCostDetailReportByOrderId',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 上报费用明细列表
export const repostCostDetailList = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/reportFeeBO.ajax?cmd=queryOrderCostDetailReports',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 司机借支 - 核销
export const verificationOaLoanCar = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/oaLoan.ajax?cmd=verificationOaLoanCar',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});
